module.exports = __webpack_public_path__ + "img/icon-speed-10.d9bd75e0.svg";